// src/features/chat/useOpenDirectConversation.ts
// One way to start a 1:1 conversation from any people-first surface (⌘K
// palette, empty-chat grid, team member page): open the DM if it exists,
// create it if not, navigate there. Creation can legitimately fail (FGA on a
// fresh user), so the hook keeps the error instead of throwing — the caller
// renders it inline, where the person clicked, rather than crashing the view.

import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { openDirectConversation } from './logic';

export function useOpenDirectConversation() {
  const navigate = useNavigate();
  const [pendingProfileId, setPendingProfileId] = useState<string | null>(null);
  const [error, setError] = useState<unknown>(null);

  const open = useCallback(async (profileId: string): Promise<boolean> => {
    if (!profileId) return false;
    setPendingProfileId(profileId);
    setError(null);
    try {
      const id = await openDirectConversation(profileId);
      navigate(`/chats/${id}`);
      return true;
    } catch (err) {
      setError(err);
      return false;
    } finally {
      setPendingProfileId(null);
    }
  }, [navigate]);

  const clearError = useCallback(() => setError(null), []);

  return { open, pendingProfileId, isOpening: pendingProfileId !== null, error, clearError };
}
